import { createStyles, makeStyles } from "@material-ui/core";
import React from "react";
import { useTranslation } from "react-i18next";
import ICommonFormProps from "../../../yoello-lib/modules/dynamicForms/interfaces/ICommonFormProps";




const useStyles = makeStyles((theme) =>
    createStyles({
        title: {
            fontSize: "1rem",
            fontWeight: 600,
            padding: '1rem 0 1rem 0'
        }
    }))


export function FormTitle({ label }: Partial<ICommonFormProps>) {
    const { t } = useTranslation();
    const classes = useStyles();
    return <div className={classes.title}>
        {t(label!)}
    </div>
}